// autogenerated
import {VisitingPointDuration, CruiseGroupSize, CruiseTimeOfDay, CruiseDuration, CruiseExtra} from "@/models/Enums";

export default class CreateCruiseOrderRequest {

    public countryCode: string | null = null;

    public areaId: string | null = null;

    public customArea: string | null = null;

    public departFrom: string | null = null;

    public departBy: Date = new Date();

    public visitPoint: string | null = null;

    public visitingPointDuration: VisitingPointDuration | null = null;

    public arriveTo: string | null = null;

    public arriveAt: Date = new Date();

    public groupSize: CruiseGroupSize = CruiseGroupSize.Standard;

    public timeOfDay: CruiseTimeOfDay = CruiseTimeOfDay.Morning;

    public duration: CruiseDuration = CruiseDuration.JustRide;

    public date: Date = new Date();

    public extras: CruiseExtra[] | null = null;

    public groupSizeValue: number = 0;

    public childrenComing: boolean = false;

    public numberOfComingChildren: number | null = null;

    public accessibilityLimitations: boolean = false;

    public accessibilityLimitationsComment: string | null = null;

    public estimatedPrice: number | null = null;

    public comment: string | null = null;

    public name: string | null = null;

    public company: string | null = null;

    public email: string | null = null;

    public phone: string | null = null;

    public agreementAccepted: boolean = false;

    public registrationAccepted: boolean = false;

    public cancellationPolicyAccepted: boolean = false;

    public readonly isCreateCruiseOrderRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof CreateCruiseOrderRequest) || ((from as any).isCreateCruiseOrderRequest === true));
    }

    public static as(from?: object | null): CreateCruiseOrderRequest | null {
        return (CreateCruiseOrderRequest.is(from)) ? from as CreateCruiseOrderRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}